module.exports = __webpack_public_path__ + "static/img/pic_141@2x.7fb9a083.png";